<!-- 获取停车记录详情接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCodeList": ['2KNTYVWC'],
          "areaIds": [],
          "enterChannelNames": [],
          "enterTimeFrom": "20190801000000",
          "enterTimeTo": "20191028235959",
          "carNo": "",
          "enterVipType": 1,
          "enterVipTypeName": "",
          "correctType": 0,
          "recordType": 1,
          "pageNum": 1,
          "pageSize": 10
        },
        responseCode: {
          "data": {
            "parkingCode": "191013095236610186193114",
            "parkCode": "2KNTYVWC",
            "parkName": "云接口测试专用停车场",
            "carNo": "云VXP0AE",
            "cardCode": "",
            "parkSysType": 1,
            "enterChannelName": "云接口测试入口",
            "enterVipType": 1,
            "enterCustomVipName": "临时车",
            "areaName": "外场区域",
            "areaId": 223,
            "enterImageArray": [
              {
                "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092909505802078030-body-in-nor.jpg?s=c5635c04",
                "plateImage": "http://221.4.168.157:13388/openydt/files/images/2017092909505802078030-plate-in-nor.jpg?s=4e699eac"
              }
            ],
            "enterTime": "20191013095245",
            "enterType": 1,
            "confidence": 85.0,
            "recordType": 1,
            "correctType": 0,
            "confirmInReason": "",
            "operator": "System"
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取停车场在场车辆信息",
          t_url: this.commonUrls.test + "getParkOnSiteCar",
          p_url: this.commonUrls.prod + "getParkOnSiteCar",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编号列表'},
              {info1: 'areaIds', info2: '否', info3: 'long[]', info4: '区域id列表'},
              {info1: 'enterChannelNames', info2: '否', info3: 'String[]', info4: '进场通道名称列表'},
              {
                info1: 'enterTimeFrom',
                info2: '是',
                info3: 'String',
                info4: '进场起始时间，格式yyyyMMddHHmmss， 起始时间与结束时间间隔不能超过1天'
              },
              {info1: 'enterTimeTo', info2: '是', info3: 'String', info4: '进场结束时间，格式yyyyMMddHHmmss， 起始时间与结束时间间隔不能超过1天'},
              {info1: 'carNo', info2: '否', info3: 'String', info4: '车牌'},
              {info1: 'enterVipType', info2: '否', info3: 'Integer', info4: '进场VIP类型（0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客）'},
              {info1: 'enterVipTypeName', info2: '否', info3: 'String', info4: '进场VIP类型名称'},
              {info1: 'correctType', info2: '否', info3: 'Integer', info4: '校正类型，0未校正，1已校正，不填时为所有'},
              {
                info1: 'enterType',
                info2: '否',
                info3: 'Integer',
                info4: '进场类型（<url>参考附录:/Api/appendixData#appendixData_5</url>）'
              },
              {info1: 'recordType', info2: '否', info3: 'Integer', info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发）'},
              {info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始'},
              {info1: 'pageSize', info2: '是 ', info3: 'Integer', info4: '每页多少条，最多1000条'},
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              { info1: 'count', info2: '否', info3: 'Integer', info4: '当前取得的记录条数' },
              {info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表'}
            ]
          }, {
            titleName: 'recordList',
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号'},
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称'},
              {info1: 'carNo', info2: '否', info3: 'String', info4: '车牌'},
              {info1: 'cardCode', info2: '否', info3: 'String', info4: '卡号'},
              {info1: 'parkSysType', info2: '是', info3: 'Integer', info4: '车场系统类型(0 VEMS停车场，1云停车场)'},
              {info1: 'enterChannelName', info2: '是', info3: 'String', info4: '进场通道名称'},
              {info1: 'enterVipType', info2: '否', info3: 'Integer', info4: '进场VIP类型（0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客）'},
              {info1: 'enterCustomVipName', info2: '否', info3: 'String', info4: '进场VIP类型名称'},
              {info1: 'areaName', info2: '是', info3: 'String', info4: '区域名称'},
              {info1: 'areaId', info2: '否', info3: 'String', info4: '区域id '},
              {
                info1: 'enterImageArray',
                info2: '是',
                info3: 'JSONObject',
                info4: '进场图片列表，[{"plateImage":"车牌图片直接访问url","carImage":"车身图片直接访问url"}]'
              },
              {info1: 'enterTime', info2: '否', info3: 'String', info4: '进场时间，格式yyyyMMddHHmmss'},
              {
                info1: 'enterType',
                info2: '否',
                info3: 'Integer',
                info4: '进场类型（<url>参考附录:/Api/appendixData#appendixData_5</url>）'
              },
              {info1: 'confidence', info2: '否', info3: 'Decimal', info4: '置信度（0-100）'},
              {info1: 'recordType', info2: '否', info3: 'Integer', info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发）'},
              {info1: 'correctType', info2: '否', info3: 'Integer', info4: '校正类型，0未校正，1已校正'},
              {info1: 'confirmInReason', info2: '否', info3: 'String', info4: '确认放行原因'},
              {info1: 'operator', info2: '否', info3: 'String', info4: '操作员'}
            ]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getParkOnSiteCar.vue